const _ = require("lodash");

const isEmpty = function(value) {
    return (_.isUndefined(value) || value === null || ((_.isString(value) || _.isObject(value)) && _.isEmpty(value)));
};

const types = [
    {
        type: "object",
        default: null
    },
    {
        type: "string",
        default: "",
        convert: function(o) { return o.toString(); }
    },
    {
        type: "integer",
        default: null,
        convert: function(o) { return parseInt(o); }
    },
    {
        type: "decimal",
        default: null,
        convert: function(o) { return parseFloat(o); }
    },
    {
        type: "financial",
        default: null,
        convert: function(o) { return parseFloat(o).toFixed(2); }
    },
    {
        type: "boolean",
        default: false,
        convert: function(o) { return o.toString() === "true"; }
    },
    {
        type: "date",
        default: null,
        convert: function(o) { return new Date(o.toString()); }
    }
];

export default types.map(function(type) {
    const name = "to" + type.type.charAt(0).toUpperCase() + type.type.slice(1);

    const $u = function(value) {
        if(isEmpty(value)) return this.list ? [] : type.default;

        try {
            const convert = type.convert || _.identity;
            if(_.isArray(value) && this.list) value = value.map(convert);
            else value = this.list ? [convert(value)] : convert(value);
        } catch(e) {
            if(! this.log) return e;
            console.log(e);
        }

        return value;
    };

    return {type: name, $u: $u};
});
